import { contractApi } from '@/core/api/contract'

export const { useGetContractQuery, useGetContractByEstablishmentQuery, useGetContractsQuery, useCreateContractMutation, useUpdateContractMutation, useDeleteContractMutation } = contractApi
